module.exports = __webpack_public_path__ + "img/band.fbdba518.webp";